// extracted by mini-css-extract-plugin
module.exports = {"profile":"ProfileControl_profile__7FoZB","icon":"ProfileControl_icon__1NEt5"};